import { IntlNumberFormat } from 'vue-i18n';

export default {
  EUR: {
    style: 'currency',
    currency: 'EUR',
  } as IntlNumberFormat,
};
